import tippy from 'tippy.js';

class Tooltips {
  public tooltips: NodeListOf<HTMLElement> | null;

  cache() {
    this.tooltips = document.querySelectorAll('[data-tooltip]');
  }

  bindings() {
    if (this.tooltips) {
      this.tooltips.forEach((tooltip) => {
        tippy(tooltip, {
          content: tooltip.dataset.content,
        });
      });
    }
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default Tooltips;
